import React from 'react';
import { motion } from 'framer-motion';
interface BrandEmblemProps {
  className?: string;
  /** Colour of the two large planes. */
  primary?: string;
  /** Colour of the top plane and the thin pillar. */
  accent?: string;
  animate?: boolean;
  title?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;

/** Vector rendering of the Bel Air B/A emblem, traced from the brand logo. */
export function BrandEmblem({
  className,
  primary = '#0B332B',
  accent = '#C6A15B',
  animate = false,
  title = 'Bel Air emblem'
}: BrandEmblemProps) {
  const pieces = [{
    points: '383,163 1016,0 1016,323 383,487',
    fill: accent,
    from: {
      x: -40,
      y: -30
    }
  }, {
    points: '383,531 1329,288 1329,1096 966,1190 966,650 383,800',
    fill: primary,
    from: {
      x: 40,
      y: 0
    }
  }, {
    points: '383,855 885,725 885,1077 383,1207',
    fill: primary,
    from: {
      x: -40,
      y: 30
    }
  }, {
    points: '885,725 930,715 930,1197 885,1209',
    fill: accent,
    from: {
      x: 0,
      y: 60
    }
  }];
  return <svg viewBox="383 0 946 1210" className={className} role="img" aria-label={title} data-id="element-201" data-mp="ee4wbj35io4q">
      {pieces.map((piece, index) => animate ? <motion.polygon key={piece.points} points={piece.points} fill={piece.fill} initial={{
      opacity: 0,
      x: piece.from.x,
      y: piece.from.y
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: EASE,
      delay: 0.1 + index * 0.08
    }} data-id="element-202" data-mp="2zt9gygh621hj" /> : <polygon key={piece.points} points={piece.points} fill={piece.fill} data-id="element-203" data-mp="2lyyt01czubcj" />)}
    </svg>;
}